import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DeleteMessageDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

/**
 * Confirmação de "apagar para todos". A ação é irreversível no WhatsApp, então
 * o gatilho no menu da bolha nunca apaga direto.
 */
export function DeleteMessageDialog({ open, onClose, onConfirm, isDeleting }: DeleteMessageDialogProps) {
  const { t } = useTranslation('chat');

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
      <DialogContent className="bg-card border-border rounded-2xl max-w-md dark:bg-[#18181B] dark:border-[#3F3F464D]">
        <DialogHeader>
          <DialogTitle className="text-foreground dark:text-white flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-red-500" />
            {t('area.deleteConfirmTitle')}
          </DialogTitle>
          <DialogDescription className="text-muted-foreground dark:text-neutral-400">
            {t('area.deleteConfirmBody')}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isDeleting}
            className="border-border text-foreground hover:bg-[#F1F5F9] dark:border-white dark:text-white dark:hover:bg-white dark:hover:text-black"
          >
            {t('common.cancel')}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-red-600 hover:bg-red-700"
          >
            {isDeleting ? t('area.deleting') : t('area.deleteConfirmCta')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
